// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import { getAuthHeaders } from "@/shared/api/authHeaders";
import { useMutation } from "@tanstack/react-query";
import { FreightMatching } from "@x-mile/api-contract";
import type { PostOffersCargosApproveMutationVariables } from "../model";

export const usePostOffersCargosApprove = () => {
  const authHeaders = getAuthHeaders();
  const mutateResult = useMutation({
    mutationFn: (variables: PostOffersCargosApproveMutationVariables) =>
      FreightMatching.postOffersCargosApprove(
        variables.id,
        // バックエンド（rails）ではキーがスネークケースになっているため、リクエストボディをスネークケースに変換する

        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return mutateResult;
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const usePostOffersCargosApproveMock = () => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getPostOffersCargosApproveMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return usePostOffersCargosApprove();
// };
